<template>
  <BaseTemplate>
    <div class="complete-password-reissue">
      <Title :jpn="t('仮パスワード送信完了')" />
      <div class="description">
        <span class="text">{{ t('登録されたメールアドレスに仮パスワードを送信しました。') }}</span>
        <span>{{ t('メールを確認してください。') }}</span>
      </div>
      <BuyButton
        class="square-button"
        :text="t('ログイン')"
        :isArrow="false"
        @handleSquareBtnClick="goToUserLogin"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';
import BuyButton from '@/components/atoms/BuyButton.vue';

export default {
  name: 'CompletePasswordReissue',
  mixins: [t],

  beforeRouteLeave(to, from, next) {
    if (to.name === 'PasswordReissue') {
      next(false);
    } else {
      next();
    }
  },

  components: {
    BaseTemplate,
    Title,
    BuyButton,
  },

  methods: {
    goToUserLogin() {
      this.$store.dispatch('user/setShowLoginPage', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.complete-password-reissue{
  max-width: 680px;
  padding: 70px 30px 0;
  margin: 0 auto;
  text-align: center;
  .description{
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    .text{
      font-family: $notoSans;
      font-size: 14px;
      line-height: 23.4px;
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 40px auto 0px;
  }
}
</style>
